import React from 'react'
import { connect } from 'react-redux'
import { ORDER_FILTER_STATUS } from '@/constants/filter-type';
import Dropdown from '@/components/Dropdown/Dropdown';
import classnames from 'classnames'
import { formatFunctions, utilsFunction } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import '@/assets/styles/components/order/order-history.scss';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { DATE_CONSTANT } from '@/constants/app';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import TabHeaderMobile from '@/components/TabHeader/TabHeader.mobile';

const ORDER_HISTORY_TABLE = 4;

class OrderHistoryMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      searchParams: {}
    }
  }

  render() {
    const { language } = this.props;
    const { orders } = this.state;

    return (
      <div className='order-history-mobile-container'>
        {this.renderOrderFilterDropdown()}
        {orders.length > 0
          ? <div className="order-list">
              {orders.map((order,index) => 
                  <div className="order-item" key={index}>
                  <header onClick={() => this.handleViewDetail(order)}>
                    <span>{`${language.common_reference_no} ${order.orderGroupID} >`}</span>
                    <span>{language[`order_type_${order.orderType.toLowerCase()}`]}</span>
                  </header>
                  <section className='info-list'>
                      <div className='info-list-left'>
                        <div className="info-item">
                            <label>{language.common_symbol}</label>
                            <span>{`${order.marketID}.${order.instrumentID}`}</span>
                        </div>
                        <div className="info-item">
                            <label>{language.common_price}</label>
                            <span>{formatFunctions.dataFormat(order.price, dataType.CURRENCY)}</span>
                        </div>
                        <div className="info-item">
                            <label>{language.common_filled_qty}</label>
                            <span>{formatFunctions.dataFormat(order.filledQty, dataType.NUMBER)}</span>
                        </div>
                        <div className="info-item">
                            <label>{language.common_avg_price}</label>
                            <span>{formatFunctions.dataFormat(order.avgPrice, dataType.CURRENCY)}</span>
                        </div>
                      </div>
                      <div className='info-list-right'>
                        <div className="info-item">
                          <label>{language.common_name}</label>
                          <span>{order.instrumentShortName}</span>
                        </div>
                        <div className="info-item">
                          <label>{language.common_buy_sell}</label>
                          <span
                              className={classnames(order.bs === 'B' ? 'buy-color' : 'sell-color')}>{language[order.bs === 'B' ? 'common_buy' : 'common_sell']}</span>
                        </div>
                        <div className="info-item">
                            <label>{language.common_quantity}</label>
                            <span>{formatFunctions.dataFormat(order.qty, dataType.NUMBER)}</span>
                        </div>
                        <div className="info-item">
                          <label>{language.common_status}</label>
                          <span>{language[`order_status_${order.status.toLowerCase()}`]}</span>
                        </div>
                      </div>
                  </section>
                  <section className="info-createTime">
                    <label>{language.common_create_time}:</label>
                    <span>{formatFunctions.dataFormat(order.inputTime, dataType.LONG_DATE)}</span>
                  </section>
                </div>
              )}
          </div>
          : <div className='no-data'>{language.common_no_data}</div>
        }
      </div>
    )
  }
  
  handleViewDetail = (order) => {
    mobileSubLayoutAction.openOrderJournalDetail(order)
  }

  renderOrderFilterDropdown() {
    const { language } = this.props;
    const { maximumDate } = this.state;
    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])

    return (
      <div className="filter-dropdown">
        <TabHeaderMobile
           innerRef={e => this.tabHeaderOrderRefMobile = e}
           dateRangePicker={true}
           maximumDate={maximumDate}
           onChangeDatePicker={this.handleChangeDatePicker}
          //  orderFilterDropdown={true}
          //  orderFilterRadio={false}
           />
        <Dropdown options={filterOptions}
          style={{ height: 'unset' }}
          selectedOptions={[filterOptions[0]]}
          onChange={(opt) => this.handleFilterByStatus(opt[0])} />
      </div>
    )
  }

  handleFilterByStatus = (val) => {
    let status = '';
    switch (val.value) {
      case 'all': {
        status = '';
        break;
      }
      default: {
        status = val.value.toUpperCase();
        break;
      }
    }
    this.setState({ searchParams: Object.assign({}, this.state.searchParams, { status }) }, () => this.getData())
  }

  handleFilterByDate = (val) => {
    const date = val.valueObject;
    const startDate = utilsFunction.modifyDateFromNow(DATE_CONSTANT.SUBTRACT, date.quantity, date.unit);
    this.setState({ searchParams: Object.assign({}, this.state.searchParams, { startDate }) }, () => this.getData())
  }

  handleChangeDatePicker = (date) => {
    const startDate = this.convertDateObjectToString(date.from);
    const endDate = this.convertDateObjectToString(date.to);
    const { searchParams } = this.state;
    if (startDate !== searchParams.startDate || endDate !== searchParams.endDate) {
      this.setState({
        searchParams: Object.assign({}, searchParams,
          {
            startDate,
            endDate
          })
      },() => {
        this.getData();
      })
    }
  }

  getData() {
    const { currentTradingAccount } = this.props
    const { searchParams } = this.state;
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: searchParams.status,
        [PARAMS.START_DATE]: searchParams.startDate,
        [PARAMS.END_DATE]: searchParams.endDate
      }
      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ orders: res.result.orderInfoList });
          }
        }
      })
    }
  }

  setStartEndDate () {
    const maximumDate = this.getMaximumDate();
    this.setState({
      orderTableTab: ORDER_HISTORY_TABLE,
      searchParams: {
        status: '',
        startDate: this.convertDateObjectToString(maximumDate),
        endDate: this.convertDateObjectToString(maximumDate)
      }
    }, () => {
      // this.tabHeaderOrderRefMobile.setDatePickerValue(maximumDate);
      this.getData();
    })
  }

  convertDateObjectToString(date) {
    return `${date.year}-${date.month}-${date.day}`
  }

  getMaximumDate() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    const maximumDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    }
    this.setState({ maximumDate })
    return maximumDate;
  }

  componentDidMount() {
    this.setStartEndDate();
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderHistoryMobile)
